/* eslint-disable default-case */
import React, { useMemo, useState, useRef, useEffect } from "react";

import {
  Dialog,
  DialogContent,
  Box,
  Card,
  Button,
  IconButton,
  Typography,
  CardContent,
  CardActions,
  AppBar,
  Toolbar,
  Link,
} from "@mui/material";
import {
  ArrowBackIosNew,
  ArrowForwardIos,
  Download,
  Close as CloseIcon,
} from "@mui/icons-material";
import "../css/GalleryDialog.css";
import logoImage from "../../../image/logo.jpeg";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

/**
 * Componente de galeria de imagens que pode ser usado para exibir
 * uma lista de imagens com opções de download e delete.
 *
 * @param {Object[]} data - Lista de objetos com atributos url, name e type
 * @returns {JSX.Element} - Elemento JSX do componente de galeria
 */
export default function GalleryDialog({ data = [] }) {
  
  const [typeFile, setTypeFile] = useState("");

  useEffect(() => {
    if (
      data.substring(data.indexOf(".png"), data.indexOf(".png") + 4) === ".png"
    ) {
      setTypeFile(".png");
    } else if (
      data.substring(data.indexOf(".pdf"), data.indexOf(".pdf") + 4) === ".pdf"
    ) {
      setTypeFile(".pdf");
    } else if (
      data.substring(data.indexOf(".jpeg"), data.indexOf(".jpeg") + 5) ===
      ".jpeg"
    ) {
      setTypeFile(".jpeg");
    }
  }, [data]);

  const attachmentData = useMemo(() => {
    return {
      createdAt: "ToDay",
      name: "Documento.....",
      type: typeFile,
      url: data,
    };
  }, [data, typeFile])
  
  const [open, setOpen] = useState(false);
  const [galleryData, setGalleryData] = useState([]);
  const carouselRef = useRef(null);

  // useEffect(() => {
  //   if (Array.isArray(data)) setGalleryData(data);
  //   else setGalleryData([]);
  // }, [data]);

  useEffect(() => {
    if (attachmentData && attachmentData.url) {
      setGalleryData([attachmentData]); //
    } else {
      setGalleryData([]);
    }
  }, [attachmentData]);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  /**
   * Função para scroll a galeria de imagens em uma direção
   * específica.
   *
   * @param {string} direction - Direção do scroll ("left" ou "right")
   */
  const scroll = (direction) => {
    if (!carouselRef.current) return;
    const scrollAmount = 424; // ajuste se necessário
    carouselRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const handleDownload = async (item) => {
    if (!item?.url) {
      alert("URL do arquivo inválida.");
      return;
    }

    const fileName = item.name || `arquivo_${Date.now()}`;
    try {
      // Primeiro tentativa: fetch + blob (força download sem abrir aba)
      const resp = await fetch(item.url, { mode: "cors" });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const blob = await resp.blob();
      const objectURL = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectURL;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectURL);
      console.log("[gallery] download via fetch ok:", fileName);
    } catch (err) {
      // fallback (padrão do navegador pode abrir em nova aba, download attr pode ser ignorado dependendo do server)
      console.warn("[gallery] fetch/download falhou, fallback anchor:", err);
      const a = document.createElement("a");
      a.href = item.url;
      a.setAttribute("download", fileName); // navegador pode ignorar se server definir Content-Disposition diferente
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      a.remove();
      alert(
        "Tentativa direta de download (caso abra em nova aba, salve a imagem a partir dela)."
      );
    }
  };

  // const handleDelete = (index) => {
  //   setGalleryData((prev) => prev.filter((_, i) => i !== index));
  // };

  // Debug helper para inspecionar item
  const debugItem = (item, index) => {
    console.log(`[gallery] item[${index}]`, item);
  };

  return (
    <div className="row gap-2 row justify-content-between align-items-center gx-3">
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {galleryData.slice(0, 5).map((item, index) => (
          <Link
            key={index}
            href={item.url}
            download={item.url}
            underline="none"
            target="_blank"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#012443",
              backgroundColor: "#f4f8ff",
              padding: "6px 10px",
            }}
          >
            <InsertDriveFileIcon
              style={{ marginRight: "6px", color: "#012443" }}
            />
            <label className="font-test">
              {item.name.slice(0, 8)}.... {item.type}
            </label>
          </Link>
        ))}

        {/* {galleryData.length > 5 && (
          <Button
            variant="contained"
            onClick={handleClickOpen}
            style={{ width: "20%", backgroundColor: "#012443" }}
          >
            Ver Documentação
          </Button>
        )} */}

        {/* <Button
          variant="contained"
          onClick={handleClickOpen}
          style={{ width: "20%", backgroundColor: "#012443" }}
        >
          Ver Documentação
        </Button> */}
      </div>

      {/*  */}

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        sx={{
          borderRadius: "16px",
        }}
      >
        <AppBar position="relative">
          <Toolbar sx={{ backgroundColor: "#012443" }}>
            {/* <Image width={200} height={50} src={logoImage} /> */}
            <Typography
              variant="h6"
              sx={{ flex: 1, fontWeight: "bold", color: "#fff" }}
            >
              Documentação
            </Typography>
            <IconButton edge="end" color="inherit" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent className="gallery-content">
          <IconButton
            className="gallery-arrow gallery-arrow-left"
            onClick={() => scroll("left")}
            style={{ backgroundColor: "#012443", color: "#fff" }}
          >
            <ArrowBackIosNew />
          </IconButton>

          <Box className="gallery-carousel-container">
            <Box ref={carouselRef} className="gallery-carousel-box">
              {galleryData.length > 0 ? (
                galleryData.map((item, index) => {
                  const fileUrl = item?.url || "";
                  const fileType =
                    (item?.type || "").toString().toLowerCase() ||
                    (fileUrl.includes(".pdf") ? "pdf" : "png");
                  const fileName = item?.name || `arquivo_${index + 1}`;

                  return (
                    <Card
                      key={index}
                      className="gallery-card"
                      onDoubleClick={() => debugItem(item, index)}
                    >
                      {/* container com altura fixa para evitar colapso */}
                      <Box className="gallery-card-media-container">
                        {fileType.includes("pdf") ? (
                          <iframe
                            src={fileUrl}
                            title={fileName}
                            width="100%"
                            height="100%"
                            className="gallery-card-iframe"
                          />
                        ) : (
                          <img
                            src={fileUrl}
                            alt={fileName}
                            className="gallery-card-img"
                            loading="lazy"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://via.placeholder.com/600x400?text=Imagem+indispon%C3%ADvel";
                              console.warn(`[gallery] img error: ${fileUrl}`);
                            }}
                          />
                        )}
                      </Box>

                      <CardContent className="gallery-card-content">
                        <Typography variant="h6" component="div" noWrap>
                          {fileName}
                        </Typography>
                      </CardContent>

                      <CardActions className="gallery-card-actions">
                        <IconButton
                          color="primary"
                          aria-label="download"
                          onClick={() => handleDownload(item)}
                        >
                          <Download />
                        </IconButton>

                        {/* <IconButton
                          color="error"
                          aria-label="delete"
                          onClick={() => handleDelete(index)}
                        >
                          <Delete />
                        </IconButton> */}
                      </CardActions>
                    </Card>
                  );
                })
              ) : (
                <Typography className="gallery-empty-text">
                  Nenhum item na galeria.
                </Typography>
              )}
            </Box>
          </Box>

          <IconButton
            className="gallery-arrow gallery-arrow-right"
            onClick={() => scroll("right")}
          >
            <ArrowForwardIos />
          </IconButton>
        </DialogContent>
      </Dialog>
    </div>
  );
}
